var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"foot_1"},[_c('div',{staticClass:"foot"},[_c('div',{staticClass:"foot02"},[_c('span',[_vm._v(_vm._s(_vm.$t('footer.concact')))])]),_vm._v(" "),_c('div',{staticClass:"foot03"},[_c('p',[_vm._v(_vm._s(_vm.$t('footer.power')))]),_vm._v(" "),_c('p',{domProps:{"innerHTML":_vm._s(_vm.$t('footer.address'))}})])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-d88a4366","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Footer.vue
// module id = null
// module chunks = 